export class GetIndexFieldList {
    constructor(indexFieldRepository) {
      this.indexFieldRepository = indexFieldRepository;
    }
  
    async execute(companyId) {
        console.log('GetIndexFieldList - companyId : '+ companyId)
      return await this.indexFieldRepository.getIndexFieldList(companyId);
    }
  }